<template>
	<div class='main-mybody'>
		<a-row>
				<a-col :span='24'>
					<div class='look_g'><div></div>個人基本資料</div>
					<a-row><a-col :span='6'>中文名稱</a-col><a-col :span='7'>   
					<a-input placeholder=" " v-model="form.name_cn"
					@input="(()=>{
						if(this.form.name_cn.replace(/^[\u4e00-\u9fa5]+$/,'')){
							this.form.name_cn= ''
						}else{
							this.form.name_cn=this.form.name_cn
						}
					})"/>
					</a-col></a-row>
					<a-row><a-col :span='6'>英文名稱</a-col><a-col :span='7'>  
					<a-input placeholder=" "  v-model="form.name_en" onkeyup="value=value.replace(/[\u4E00-\u9FA5]/g,'')"/></a-col></a-row>
					<a-row><a-col :span='6'>性別</a-col><a-col :span='7'>  
					 <a-select v-model='form.sex' style="width: 100%" >
					      <a-select-option :value="2">
					        女
					      </a-select-option>
					      <a-select-option :value="1">
					        男
					      </a-select-option>
					    </a-select>
					</a-col></a-row>
					<a-row><a-col :span='6'>婚姻狀況</a-col><a-col :span='7'>  
					<a-select v-model='form.ismarryed' style="width: 100%" >
					     <a-select-option :value="1">
					       已婚
					     </a-select-option>
					     <a-select-option :value="2">
					       未婚
						 </a-select-option>
					   </a-select>
					</a-col></a-row>
					<a-row><a-col :span='6'>國籍</a-col><a-col :span='7'>  
					<a-input placeholder=" " v-model='form.nationality'/></a-col></a-row>
					<a-row><a-col :span='6'>出生日期</a-col><a-col :span='7'> {{form.birth}}</a-col></a-row>
					<div class='main-wid'></div>
				</a-col>
				<a-col :span='24'>
					<div class='look_g'><div></div>聯絡資料</div>
					<a-row><a-col :span='6'>工作電子郵箱地址</a-col><a-col :span='7'> {{form.email}}</a-col></a-row>
					<a-row><a-col :span='6'>工作電話號碼</a-col><a-col :span='7'> 
					<a-input placeholder=" " v-model='form.phone' onkeyup="value=value.replace(/[^\d]/g,'') "/></a-col></a-row>
					<a-row><a-col :span='6'>手機號碼</a-col><a-col :span='7'> {{form.telphone}}</a-col></a-row>
					<a-row><a-col :span='6' >住宅地址</a-col><a-col :span='7'>  
					<div style="display: flex;justify-content: space-between;">
						<a-input placeholder=" " v-model='form.homeaddress' style='width: 72%;'/>
						<a-upload
						    name="avatar"
						    class="avatar-uploader"
						    :show-upload-list="false"
						    :before-upload="beforeUpload"
						    @change="handleChange"
						  >
						<a-button style='margin-left: 1%;' >+ 上傳地址</a-button>
						  </a-upload>
					</div>
					</a-col></a-row>
					<div class='main-wid'></div>
				</a-col>
				<!-- <a-col :span='24'>
					<div class='look_g'><div></div>工作地址</div>
					<a-row><a-col :span='6'>營業地址</a-col><a-col :span='7'>  xxx</a-col></a-row>
					<a-row><a-col :span='6'>地址</a-col><a-col :span='7'>   </a-col></a-row>
					<a-row><a-col :span='6'>城市</a-col><a-col :span='7'>   </a-col></a-row>
					<a-row><a-col :span='6'>國家/地區/州</a-col><a-col :span='7'>   </a-col></a-row>
					<a-row><a-col :span='6'>郵政編號</a-col><a-col :span='7'>   </a-col></a-row>
					<div class='main-wid'></div>
				</a-col> -->
				<!-- <a-col :span='24'>
					<div class='look_g'><div></div>公司資料</div>
					<a-row><a-col :span='6'>公司名稱</a-col><a-col :span='7'>   </a-col></a-row>
					<a-row><a-col :span='6'>公司的國家/地區代碼</a-col><a-col :span='7'>   </a-col></a-row>
					<a-row><a-col :span='6'>使用者部門/職位</a-col><a-col :span='7'>   </a-col></a-row>
					<a-row><a-col :span='6'>員工編碼</a-col><a-col :span='7'>   </a-col></a-row>
					<div class='main-wid'></div>
				</a-col> -->
				<a-col :span='24'>
					<div class='look_g'><div></div>緊急聯絡</div>
					<a-row><a-col :span='6'>聯絡人姓名</a-col><a-col :span='7'>  
					 <a-input placeholder=" " v-model='form.emergency_name'/></a-col></a-row>
					<a-row><a-col :span='6'>聯絡人電話</a-col><a-col :span='7'> 
					  <a-input placeholder=" " v-model='form.emergency_phone' 
					   onkeyup="value=value.replace(/[^\d]/g,'') "/></a-col></a-row>
					<div class='main-wid'></div>
				</a-col>
				<a-col :span='24'>
					<div class='look_g'><div></div>個人偏好</div>
					<a-row><a-col :span='6'>偏好的語言</a-col><a-col :span='7'>  
					<a-select v-model='form.language_love' style="width: 100%" >
					     <a-select-option value="中文（繁体）">
					       中文（繁体）
					     </a-select-option>
					   </a-select></a-col></a-row>
					<a-row><a-col :span='6'>偏好的時區</a-col><a-col :span='7'> 
					<a-select v-model='form.timezone_love' style="width: 100%" >
					     <a-select-option value="香港時區">
					       香港時區
					     </a-select-option>
					   </a-select></a-col></a-row>
				</a-col>
		</a-row>
	</div>
</template>

<script>
	function getBase64(img, callback) {
		const reader = new FileReader();
		reader.addEventListener('load', () => callback(reader.result));
		reader.readAsDataURL(img);
	}
	export default {
		props:['lookfrom'],
		data(){
			return {
					form:{}
			}
		},
		watch:{
			lookfrom:{
				deep:true,
				immediate:true,
				handler(ev){
					console.log(this.lookfrom)
					// if(ev){
						let obj = JSON.parse(JSON.stringify(this.lookfrom))
						 if(obj.sex !== 1 && obj.sex!==2){
						 			obj.sex = ''	 
						 }
						 if(obj.ismarryed !== 1 && obj.ismarryed!==2){
							 obj.ismarryed = ''
						 }
						 this.form = obj
						console.log(this.form)
					// }
				}
			}
		},
		mounted() {
			// console.log(this.lookfrom)
			//  let obj = JSON.parse(JSON.stringify(this.lookfrom))
			//  if(obj.sex == 1 || obj.sex==2){
			 				 
			//  }else{
			//  		 obj.sex = ''
			//  }
			//  if(obj.ismarryed == 1 || obj.ismarryed==2){
				 
			//  }else{
			// 	 obj.ismarryed = ''
			//  }
			// this.form = obj
			// console.log(this.form)
		},
		methods:{
			beforeUpload(file){
				// 
				const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
				if (!isJpgOrPng) {
					this.$message.error('You can only upload JPG file!');
				}
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error('Image must smaller than 2MB!');
				}
				return isJpgOrPng && isLt2M;
			},
			handleChange(info){
				if (info.file.status === 'uploading') {
					this.loading = true;
					return;
				}
				// if (info.file.status === 'done') {
				// Get this url from response in real world.
				getBase64(info.file.originFileObj, imageUrl => {
					console.log(imageUrl)
					this.form.homeaddress_pic = imageUrl;
					this.loading = false;
				});
			},
			numfn(val) {
				if(this.form[val]){
					if (isNaN(this.form[val])) {
						this.form[val] = ''
					} else {
						this.form[val] = parseInt(this.form[val])
					}
				}
			},
		}
	}
</script>

<style>
</style>
